import { ChainedCommands, CommandProps, Editor } from '@tiptap/core';
import { Transaction } from '@tiptap/pm/state';

export const setTransactionMetaByAskAiAction = (tr: Transaction) => {
  tr.setMeta('byAskAiAction', true);
};
export const setTransactionMetaByAskAiActionCommand = ({
  tr,
}: CommandProps) => {
  setTransactionMetaByAskAiAction(tr);

  return true;
};
declare module '@tiptap/core' {
  interface Editor {
    chainWithAskAiActionMeta: () => ChainedCommands;
  }
}

Editor.prototype.chainWithAskAiActionMeta = function (): ChainedCommands {
  return this.chain().command(setTransactionMetaByAskAiActionCommand);
};

export const editorChainWithAskAiActionMeta = (
  editor: Editor,
): ChainedCommands => {
  return editor.chainWithAskAiActionMeta();
};
